import { ref, reactive, computed, watch } from 'vue'
import { defineStore } from 'pinia';
import { useRequestsStore } from '@/stores/storeRequests';
import { useDishesStore } from '@/stores/storeDishes';

export const useFieldsStore = defineStore('fields', () => {      

    const storeRequests = useRequestsStore();
    const storeDishes = useDishesStore();

    const fields = ref({
        firstName: {
            title: '',
            disabledBtn: false,
        },
        lastName: {
            title: '',
            disabledBtn: false,
        },
        email: {
            title: '',
            disabledBtn: false,
        },
        phone: {
            title: '',
            disabledBtn: false,
        },
        password: {
            title: '',
            disabledBtn: false,
        },
        passwordRepeat: {
            title: '',
            disabledBtn: false,
        },
        rules: {
            title: false,
            disabledBtn: false,
        },
        agreement: {
            title: false,
            disabledBtn: false,
        },
        advertising: {
            title: false,
            disabledBtn: false,
        },
        city: {
            title: '',
            disabledBtn: false,
        },
        restaurant: {
            title: '',
            disabledBtn: false,
        },
        restaurant_address: {
            title: '',
            disabledBtn: false,
        },
        about_myself: {
            title: '',
            disabledBtn: false,
        },
        reason: {
            title: '',
            disabledBtn: false,
        },
        select: {
            id: '',
            disabledBtn: false,
        },
        message: {
            title: '',
            disabledBtn: false,
        },
        files: [],
        filesForPost: [],
        photoUser: null,
        photoMenu: null,
    });      

  

    const isFeedbackBtn = computed(() => {
        return !fields.value.firstName.disabledBtn || 
        !fields.value.email.disabledBtn ||
        !fields.value.select.disabledBtn ||
        !fields.value.message.disabledBtn ||
        !fields.value.agreement.disabledBtn 
        
    })
    const isRegestrationBtn = computed(() => 
        !fields.value.firstName.disabledBtn || 
        !fields.value.phone.disabledBtn || 
        !fields.value.email.disabledBtn ||
        !fields.value.agreement.disabledBtn ||
        !fields.value.rules.disabledBtn ||
        !fields.value.passwordRepeat.disabledBtn ||
        !fields.value.password.disabledBtn 
    )    
    const isApplicationBtn = computed(() => 
        !fields.value.photoUser || 
        !fields.value.restaurant.disabledBtn ||
        !fields.value.restaurant_address.disabledBtn ||
        !fields.value.city.disabledBtn ||
        !fields.value.about_myself.disabledBtn ||
        !fields.value.reason.disabledBtn ||
        !storeDishes.isAllDishesValid
    )    
    const isApplicationExtraBtn = computed(() => 
        !fields.value.photoMenu ||
        !storeDishes.isAllExtraDishesValid
    )   
    const isAuthorizationBtn = computed(() => 
        !fields.value.email.disabledBtn ||
        !fields.value.password.disabledBtn 
    )
    const isCahngePasswordBtn = computed(() =>         
        !fields.value.passwordRepeat.disabledBtn ||
        !fields.value.password.disabledBtn 
    )
    const isRecoveryPasswordBtn = computed(() => !fields.value.email.disabledBtn )

    const updateFields  = (fieldName, fieldKey, value) => {
        if(fields.value[fieldName]) {
            fields.value[fieldName][fieldKey] = value;
        } else {
            console.log('updateFields:', fields.value[fieldName], value);
        }          
    }
   
    const updateFiles = () => {
        fields.value.files = [];   
        fields.value.filesForPost = []; 
    } 

    const updateRegestrationBtn = () => {
        fields.value.firstName.disabledBtn = false 
        fields.value.password.disabledBtn = false 
        fields.value.phone.disabledBtn = false 
        fields.value.email.disabledBtn = false
        fields.value.agreement.disabledBtn = false
        fields.value.rules.disabledBtn = false 
    }

    const updatePasswords = () => {
        fields.value.password.disabledBtn = false 
        fields.value.passwordRepeat.disabledBtn = false 
    }

    return {		
        updateFields,
        updateFiles,
        updateRegestrationBtn,
        updatePasswords,

        fields,
        isFeedbackBtn, 
        isRegestrationBtn,  
        isAuthorizationBtn,
        isRecoveryPasswordBtn,    
        isCahngePasswordBtn,
        isApplicationBtn,
        isApplicationExtraBtn,
	}
})
